require("./bootstrap");
import * as Sentry from "@sentry/browser"
import Vue from "vue";

import VueMoment from "vue-moment";
import moment from "moment-timezone";
import VCalendar from "v-calendar";

import vuetify from "../plugins/vuetify";
import Vuex from "vuex";
import router from "./router";
import store from "./store";
import wysiwyg from "vue-wysiwyg";
import DatetimePicker from "vuetify-datetime-picker";
import {BootstrapVue, IconsPlugin} from "bootstrap-vue";
/** Expert Portal **/
import "./front-end-components/_global";

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
Vue.use(Vuex);
Vue.use(DatetimePicker);
Vue.use(VCalendar, {
    componentPrefix: "vc",  // Use <vc-calendar /> instead of <v-calendar />
});
Vue.use(VueMoment, {moment});
Vue.use(wysiwyg, {
    hideModules: {"image": true, forcePlainTextOnPaste: true},
});
Vue.component("VuePagination", require("laravel-vue-pagination"));

// Stops the mouse wheel from silently changing the value of a focused
// <input type="number">. Blurring the input cancels the increment and lets
// the page scroll normally.
Vue.directive("no-wheel", {
    inserted(el) {
        const input = el.tagName === "INPUT" ? el : el.querySelector("input");
        if (input) {
            input.addEventListener("wheel", () => input.blur());
        }
    },
});

Vue.component("VuetifyCal", require("./components/VuetifyCal").default);
// Vue.component('AdminCalApp',require('./components/AdminCalApp').default);
// Vue.component('AppointmentCal',require('./components/AppointmentCal').default);

// Passport components
Vue.component("PassportClients", require("./components/passport/Clients.vue"));
Vue.component("PassportAuthorizedClients", require("./components/passport/AuthorizedClients.vue"));
Vue.component("PassportPersonalAccessTokens", require("./components/passport/PersonalAccessTokens.vue"));

// components
Vue.component("AdminDeleteUserDialog", require("./components/admin/DeleteUserDialog").default);
Vue.component("AdminStaffView", require("./components/admin/staff/View").default);
Vue.component("AdminStaffAssigned", require("./components/admin/StaffAssigned").default);
Vue.component("AdminMainStaffSelect", require("./components/admin/MainStaffSelect").default);
Vue.component("AdminUserAvatar", require("./components/admin/UserAvatar").default);
Vue.component("ExpertTermsReminderButton", require("./components/admin/expert/ExpertTermsReminderButton").default);
Vue.component("ExpertTermsRemindersHistory", require("./components/admin/expert/ExpertTermsRemindersHistory").default);

// calendar
Vue.component("CalendarCancelMeetingDialog", require("./components/calendar/CancelMeetingDialog").default);

Vue.component("AlphaCalendarCancelMeeting", require("./components/AlphaCalendarCancelMeeting").default);
Vue.component("AlphaCalendarCancelMeetingDialog", require("./components/AlphaCancelMeetingDialog").default);

// Expert
Vue.component("ExpertSendWelcomeEmailButton", require("./components/admin/expert/SendWelcomeEmailButton").default);
Vue.component("ExpertUpdatePaymentButton", require("./components/admin/expert/UpdatePaymentBtn").default);
Vue.component("ExpertSearchList", require("./components/admin/expert/search/List").default);
Vue.component("ExpertSimpleList", require("./components/admin/expert/List").default);
Vue.component("ExpertResultBlock", require("./components/admin/expert/ResultBlock").default);
Vue.component("ExpertResultSummaryBlock", require("./components/admin/expert/ResultSummaryBlock").default);
Vue.component("ExpertResultSummaryUpdateButton", require("./components/admin/expert/ResultSummaryUpdateButton").default);
Vue.component("ExpertSummarySelectButton", require("./components/admin/expert/SummarySelectButton").default);
Vue.component("ExpertJobExperience", require("./components/admin/expert/job/Experience").default);
Vue.component("ExpertSearchBar", require("./components/admin/expert/search/SearchBar").default);
Vue.component("AssignmentStatusSelect", require("./components/AssignmentStatusSelect").default);
Vue.component("EntitySelect", require("./components/EntitySelect").default);
Vue.component("CompanyNameSelect", require("./components/CompanyNameSelect").default);
Vue.component("JobTitleSelect", require("./components/JobTitleSelect").default);
Vue.component("ExpertView", require("./components/admin/expert/View").default);
Vue.component("ExpertCommentListBlock", require("./components/admin/expert/ExpertCommentListBlock").default);
Vue.component("ExpertResumeUpload", require("./components/admin/expert/ResumeUpload").default);
Vue.component("ExpertHourlyRateUpdate", require("./components/admin/expert/HourlyRateUpdate").default);
Vue.component("ExpertPaymentRequest", require("./components/admin/expert/PaymentRequest").default);

// Project
Vue.component("ProjectNavbar", require("./components/admin/project/Navbar").default);
Vue.component("ProjectNotes", require("./components/admin/project/ProjectNotes").default);
Vue.component("ProfileQuestions", require("./components/admin/project/ProfileQuestions").default);
Vue.component("InvoiceManagementPage", require("./components/admin/invoice/InvoiceManagementPage.vue").default);
Vue.component("InvoiceHistoryPage", require("./components/admin/invoice/InvoiceHistoryPage.vue").default);

Vue.component("BladeEditor", require("./components/BladeEditor").default);
Vue.component("VueEditorCleanText", require("./components/Vue2EditorComponent").default);
Vue.component("AlphaCalendar", require("./components/AlphaCalendar").default);
Vue.component("CustomTimeItems", require("./components/calendar/CustomTimeItems").default);
Vue.component("AvailabilityModal", require("./components/calendar/AvailabilityModal").default);
Vue.component("AlphaCalendarAvailability", require("./components/AlphaCalendarAvailability").default);

//Credit Tracking
Vue.component("StaffCreditTrackingTable", require("./components/admin/credit/StaffCreditTrackingTable").default);
Vue.component("StaffProjectListTable", require("./components/admin/credit/StaffProjectListTable").default);
Vue.component("StaffCreditFilterAndTable", require("./components/admin/credit/StaffCreditFilterAndTable").default);
Vue.component("OtherStaffCreditTable", require("./components/admin/credit/OtherStaffCreditTable").default);
Vue.component("ExpertPendingPaymentList", require("./components/admin/credit/ExpertPendingPaymentList").default);
Vue.component("ClientEngagementDashboard", require("./components/admin/client/EngagementDashboard").default);
Vue.component("PaymentRequestUpdateLogs", require("./components/admin/expert/PaymentRequestUpdateLogs").default);

Vue.component("VacationTrackerManager", require("./components/admin/vacation/VacationTrackerManager.vue").default);
Vue.component("ManagerVacationTracker", require("./components/admin/vacation/ManagerVacationTracker.vue").default);
Vue.component("StaffVacationTracker", require("./components/admin/vacation/StaffVacationTracker.vue").default);
Vue.component("StaffVacationTrackerTable", require("./components/admin/vacation/StaffVacationTrackerTable.vue").default);
Vue.component("StaffVacationRequestButton", require("./components/admin/vacation/StaffVacationRequestButton.vue").default);
Vue.component("StaffHolidayWorkRequestButton", require("./components/admin/vacation/StaffHolidayWorkRequestButton.vue").default);
Vue.component("StaffVacationList", require("./components/admin/vacation/StaffVacationList.vue").default);
Vue.component("StaffHolidayWorkList", require("./components/admin/vacation/StaffHolidayWorkList.vue").default);
Vue.component("HolidayWorkListTable", require("./components/admin/vacation/elements/HolidayWorkListTable.vue").default);
Vue.component("VacationDashboardSummary", require("./components/admin/vacation/elements/VacationDashboardSummary.vue").default);
Vue.component("VacationPendingRequests", require("./components/admin/vacation/elements/VacationPendingRequests.vue").default);
Vue.component("HolidayWorkRequestsList", require("./components/admin/vacation/elements/HolidayWorkRequestsList.vue").default);
Vue.component("VacationCalendar", require("./components/admin/vacation/elements/VacationCalendar.vue").default);
Vue.component("UpcomingHolidays", require("./components/admin/vacation/elements/UpcomingHolidays.vue").default);

//add sendgrid list component
Vue.component("SendgridEvents", require("./components/admin/sendgrid/SendgridEvents.vue").default);

//add dashboard components
Vue.component("LatestExpertResponses", require("./components/admin/dashboard/LatestExpertResponses.vue").default);
Vue.component("LatestClientEnquiries", require("./components/admin/dashboard/LatestClientEnquiries.vue").default);
Vue.component("StaffTargetsCard", require("./components/admin/dashboard/StaffTargetsCard.vue").default);
Vue.component("TeamTargetsTable", require("./components/admin/dashboard/TeamTargetsTable.vue").default);

//staff report components
Vue.component("DailyReportForm", require("./components/admin/staff_report/DailyReportForm.vue").default);
Vue.component("ReportChart", require("./components/admin/staff_report/ReportChart.vue").default);
/** Expert Portal **/

// Rich text pasted from MS Word/Outlook keeps Office namespaced tags (<o:p>, <w:...>, <v:...>, <st1:...>).
// Blade renders that HTML inside #app, so Vue compiles it as template; tell Vue these are not components.
Vue.config.ignoredElements = [/^o:/, /^w:/, /^v:/, /^m:/, /^st1:/];

const app = new Vue({
    vuetify,
    el: "#app",
    comments: true,
    router,
    store,
});
